/**
 * RFC 3986 URL parsing regex pattern with IPv6 support
 *
 * Pattern groups:
 * 1. scheme (protocol)
 * 2. authority (//user:pass@host:port)
 * 3. userinfo (user:pass@)
 * 4. host (including IPv6 addresses in brackets)
 * 5. port
 * 6. path
 * 7. query
 * 8. fragment
 *
 * @see https://datatracker.ietf.org/doc/html/rfc3986#appendix-B
 */
export const URL_REGEX =
  /^(?:([^:/?#]+):)?(?:\/\/((?:([^@/?#]*)@)?(\[[^\]]+\]|[^:/?#]*)(?::(\d+))?))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?$/;

/**
 * Character sets for URL encoding
 */
export const UNRESERVED_CHARS = /[A-Za-z0-9\-_.~]/;
export const RESERVED_CHARS = /[:/?#[\]@!$&'()*+,;=]/;

/**
 * Path segment validation
 */
export const PATH_SEGMENT_REGEX = /^[A-Za-z0-9\-_.~!$&'()*+,;=:@%/]*$/;

/**
 * Valid URL schemes (protocols)
 */
export const VALID_SCHEMES = ['http', 'https', 'ftp', 'ftps', 'mailto', 'tel', 'data', 'file'] as const;

/**
 * Default ports for common protocols
 */
export const DEFAULT_PORTS: Record<string, number> = {
  http: 80,
  https: 443,
  ftp: 21,
  ftps: 990,
};
